import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import dayjs from "dayjs";
import React from "react";
var ArticleItem = function(param) {
    var date = param.date, publicationName = param.publicationName, sectionName = param.sectionName, title = param.title, summary = param.summary, href = param.href;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "py-3 mb-4 border-gray-200 border-b-2",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-gray-500 uppercase text-xs pb-2",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            children: publicationName
                        }),
                        "\xa0|\xa0",
                        /*#__PURE__*/ _jsx("span", {
                            className: "date",
                            children: dayjs(date).format("MMM D, YYYY")
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-gray-500 uppercase text-sm py-2",
                    children: /*#__PURE__*/ _jsx("span", {
                        children: sectionName
                    })
                }),
                /*#__PURE__*/ _jsx("h2", {
                    children: /*#__PURE__*/ _jsx("a", {
                        className: "text-xl hover:underline pb-2",
                        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL).concat(href),
                        rel: "noreferrer",
                        target: "_blank",
                        children: title
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "article-summary",
                    children: /*#__PURE__*/ _jsx("div", {
                        dangerouslySetInnerHTML: {
                            __html: summary
                        }
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "readmore",
                    children: /*#__PURE__*/ _jsx("a", {
                        className: "uppercase hover:underline font-semibold text-xs text-danger2",
                        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL).concat(href),
                        rel: "noreferrer",
                        target: "_blank",
                        children: "Read More"
                    })
                })
            ]
        })
    });
};
export default ArticleItem;
